import {useComputed} from "@preact/signals-react";
import {useCallback} from "react";

import {brandForm, newProductsLoadingRow, newProductsMultipleRowsEdit, newProductsRowCreateSkuClicked, newProductsRowEditClicked, skuForm} from "../@signals";

export default function useUnmatchedNewProductsTable(rowData) {
	const rowEditClicked = useComputed(() => newProductsRowEditClicked.value === rowData.key)
	const rowIsLoading = useComputed(() => newProductsLoadingRow.value.includes(rowData.key))
	const rowCreateSkuClicked = useComputed(() => newProductsRowCreateSkuClicked.value === rowData.key)
	

	const handleEditRowClick = useCallback(() => {
		newProductsRowEditClicked.value = rowData.key
	}, [JSON.stringify(rowData.key)])

	const handleCreateSkuRowClick = useCallback(() => {
		newProductsRowCreateSkuClicked.value = rowData.key
	}, [JSON.stringify(rowData.key)])

	const handleMultipeEditClick = () => {
		const firstBrandID = rowData[0].brandID
		const allSameBrands = rowData.every(rowData => rowData.brandID === firstBrandID)
		allSameBrands ? brandForm.value = firstBrandID : brandForm.value = null
		skuForm.value = null
		newProductsMultipleRowsEdit.value = rowData
	}

	return {
		rowEditClicked: rowEditClicked.value,
		rowIsLoading: rowIsLoading.value,
		rowCreateSkuClicked: rowCreateSkuClicked.value,
		handleEditRowClick,
		handleMultipeEditClick,
		handleCreateSkuRowClick
	}
}